module.exports = __webpack_public_path__ + "static/img/p1.760c247.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/law/p1.jpg
// module id = UOZC
// module chunks = 12